import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faArchive, faChartBar, faInfoCircle, faLocationArrow, faTrash, faUndo, } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BButton } from "bootstrap-vue";
import { computed } from "vue";
import { useHistoryStore } from "@/stores/historyStore";
import localize from "@/utils/localization";
import { bytesToString } from "@/utils/utils";
export default /*#__PURE__*/ _defineComponent({
    __name: 'SelectedItemActions',
    props: {
        data: null,
        isRecoverable: { type: Boolean },
        itemType: null,
        isArchived: { type: Boolean, default: false },
        canEdit: { type: Boolean, default: false }
    },
    emits: ["set-current-history", "view-item", "undelete-item", "permanently-delete-item"],
    setup(__props, { emit }) {
        const props = __props;
        const { currentHistoryId } = useHistoryStore();
        library.add(faArchive, faChartBar, faInfoCircle, faLocationArrow, faTrash, faUndo);
        const label = computed(() => { var _a, _b; return (_b = (_a = props.data) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : "No data"; });
        const prettySize = computed(() => { var _a, _b; return bytesToString((_b = (_a = props.data) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : 0); });
        const viewDetailsIcon = computed(() => (props.itemType === "history" ? "chart-bar" : "info-circle"));
        const canSetAsCurrent = computed(() => props.itemType === "history" && props.data.id !== currentHistoryId);
        function onUndeleteItem() {
            emit("undelete-item", props.data.id);
        }
        function onSetCurrentHistory() {
            emit("set-current-history", props.data.id);
        }
        function onViewItem() {
            emit("view-item", props.data.id);
        }
        function onPermanentlyDeleteItem() {
            emit("permanently-delete-item", props.data.id);
        }
        return { __sfc: true, currentHistoryId, props, label, prettySize, viewDetailsIcon, canSetAsCurrent, emit, onUndeleteItem, onSetCurrentHistory, onViewItem, onPermanentlyDeleteItem, FontAwesomeIcon, BButton, localize };
    }
});
